import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'

function ReservationSummaryCard({
  classes,
  translate,
  expanded,
  propertyInfo,
  bookingInfo,
  dateIn,
  dateOut,
  onSelectRoom
}) {
  return (
    <Card className={classes.card} raised>
      <Collapse
        in={expanded}
        timeout="auto"
        unmountOnExit
        classes={{ wrapperInner: classes.mydiv }}
      >
        <div className={classes.details}>
          <div className={classes.detailsHeader}>
            <Grid item xs={12} sm={7} className={classes.propertyDetails}>
              <CardContent className={classes.content}>
                <Typography component="h5" variant="h5">
                  {propertyInfo.property_name}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {propertyInfo.address}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {translate('phoneLabel') + propertyInfo.phone}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  E-Mail: {propertyInfo.contact_email}
                </Typography>
                <Divider variant="middle" className={classes.divideSection} />
                <Typography component="h5" variant="h5">
                  {translate('reservationTitle')}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  Check in: {String(dateIn)}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  Check out: {String(dateOut)}{' '}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {translate('guestsLabel') + bookingInfo.totalGuests}{' '}
                </Typography>
              </CardContent>
            </Grid>
            <Grid item xs={12} sm={5} className={classes.propertyImage}>
              <CardMedia
                className={classes.cover}
                image={propertyInfo.logo}
                title="Property Logo"
              />
            </Grid>
          </div>
          <Grid item className={classes.roomDetails}>
            <CardHeader title={translate('chooseRoomLabel')} />
            <CardContent className={classes.content}>
              {Array.isArray(bookingInfo.rooms) &&
                bookingInfo.rooms.map((room, index, rooms) => (
                  <div className={classes.section2} key={room.id}>
                    <Typography variant="subtitle1">{room.roomName}</Typography>
                    <Typography variant="subtitle1">
                      {translate('guestSubtitle') + room.emptyGuests}
                    </Typography>
                    <Button
                      variant="contained"
                      disabled={room.emptyGuests <= 0}
                      color="default"
                      onClick={() =>
                        onSelectRoom(
                          room.roomName,
                          room.guests,
                          room.emptyGuests,
                          room.id
                        )
                      }
                    >
                      Checkin
                      <PlayArrowIcon className={classes.rightIcon} />
                    </Button>
                    <Divider
                      className={classes.divideSection}
                      style={{
                        display: rooms.length - 1 === index ? 'none' : 'visible'
                      }}
                    />
                  </div>
                ))}
            </CardContent>
          </Grid>
        </div>
      </Collapse>
    </Card>
  )
}

const styles = (theme) => ({
  card: {
    maxWidth: 800,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  details: {
    width: '100%',
    overflow: 'auto'
  },
  detailsHeader: {
    display: 'flex',
    flex: '1 1',
    flexDirection: 'row',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  content: {
    flex: '1 0 auto'
  },
  cover: {
    width: 250,
    height: 250,
    backgroundSize: 'contain'
  },
  mydiv: {
    display: 'flex'
  },
  section2: {},
  divideSection: {
    marginLeft: 0,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  roomDetails: {
    width: '100%',
    clear: 'left'
  },
  propertyDetails: {
    float: 'left'
  },
  propertyImage: {
    float: 'left',
    order: -1
  }
})

export default withStyles(styles)(withTranslate(ReservationSummaryCard))
